var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("gg-input-label", [_vm._v("Add Recipients")]),
          _c(
            "v-combobox",
            {
              staticClass: "gg-input",
              attrs: {
                multiple: "",
                dense: "",
                outlined: "",
                chips: "",
                "deletable-chips": "",
                "error-messages": _vm.errorMessages,
                name: _vm.name
              },
              model: {
                value: _vm.model,
                callback: function callback($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            },
            [
              _c("template", {
                slot: "append"
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }